import { Validation } from '@bingads-webui/validation';
import _ from 'underscore';
import { BaseFactory } from './rules-factory/base-factory';
import { EnumFactory } from './rules-factory/enum-factory';
import { NumberFactory } from './rules-factory/number-factory';
import { StringFactory } from './rules-factory/string-factory';
import { ArrayFactory } from './rules-factory/array-factory';
import { BigIntFactory } from './rules-factory/bigint-factory';

// Removed duplicate/obsolete type imports. IValidationRule has been renamed to IValidationRuleChain, IValidationRuleOptions, or IValidationRuleFn as appropriate, so it is no longer directly imported.
import { IFieldSchema, IValidationRules, IRuleFactory } from '../types';

// Removed local II18n in favor of the imported version

/**
 * Find validation rules factory by field type
 * @param {IFieldSchema} prop - Schema field properties
 * @param {I18nModel} i18n - i18n for localization
 * @returns {IRuleFactory} - returns factory for validation rules
 */
function getRuleFactoryByType(prop: IFieldSchema, i18n: I18nModel): IRuleFactory {
  switch (prop.type) {
    case 'bigint':
      return new BigIntFactory({ prop, i18n });
    case 'integer':
      return new NumberFactory({ prop: _.defaults({ decimalLength: 0 }, prop), i18n });
    case 'number':
      return new NumberFactory({ prop: _.defaults({ decimalLength: 2 }, prop), i18n });
    case 'boolean':
      return new EnumFactory({ prop: { enum: [true, false] }, i18n });
    case 'string':
      return prop.enum ? new EnumFactory({ prop, i18n }) : new StringFactory({ prop, i18n });
    case 'array':
      return new ArrayFactory({ prop, i18n });
    default:
      return new BaseFactory({ prop, i18n });
  }
}

/**
 * Create validation rules by field type
 * @param {IFieldSchema} prop - Schema field properties
 * @param {I18nModel} i18n - i18n for localization
 * @returns {IValidationRules} - returns validation rules
 */
export function createValidation(prop: IFieldSchema, i18n: I18nModel): IValidationRules {
  const factory = getRuleFactoryByType(prop, i18n);

  const rules = factory.create();

  if (prop.required) {
    // allowspace means whether value with pure spaces is treated as valid
    const allowSpace = _.result(prop, 'allowSpace', false);

    rules.required = Validation.required(allowSpace, i18n) as any;
  }

  return rules;
}
